<template>
  <!-- 输入当前用户的密码后，自动隐藏遮罩，用于保护敏感信息 -->
  <div class="unlock-mask" v-if="showMask" >
    <div class="unlock-box">
      <div>请输入密码以访问敏感信息</div>
      <el-input type="password" v-model="password" placeholder="请输入密码" clearable show-password class="password-input" ></el-input>
      <el-button type="primary" class="unlock-btn" @click="confirmPwd">确认</el-button>
    </div>
  </div>

</template>

<script>
export default {
  name: "SecurityMask",
  data() {
    return {
      password: '',
      showMask: true
    }
  },
  methods: {
    async confirmPwd() {
      let checkResult = await this.$http('sysUserService.checkPassword', {password: this.password});
      if (checkResult == true) {
        this.showMask = false;
      } else {
        this.$message.error('校验未通过，请重新输入');
      }
    }
  }
}
</script>

<style scoped>

/* 遮罩层样式 */
.unlock-mask {
  position: fixed;
  top: 0;
  left: 200px; /* 避开左侧菜单 */
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.85);
  backdrop-filter: blur(5px);
  z-index: 5;
  display: flex;
  justify-content: center;
  align-items: center;
}

/* 密码输入框样式 */
.unlock-box {
  background: white;
  padding: 30px;
  border-radius: 8px;
  width: 300px;
  text-align: center;
  box-shadow: 0 5px 15px rgba(0,0,0,0.3);
}

.password-input {
  width: 100%;
  padding: 12px;
  margin: 15px 0;
  border-radius: 4px;
  font-size: 16px;
}

.unlock-btn {
  background: #3498db;
  color: white;
  border: none;
  padding: 10px 20px;
  border-radius: 4px;
  cursor: pointer;
  transition: background 0.3s;
}

</style>